import { formatLength } from '@mawkeb/shared/units';
import { useEffect, useMemo, useState } from 'react';
import { buildPlanDrawing, fitPlan, planMapping } from '../engine/planDrawing';
import { useVenue, venue } from '../state/store';

/**
 * The floor plan, drawn from the measured model the moment the manifest arrives, while the 3D
 * engine is still downloading. It fits exactly as the plan view does, so the hand-over is seamless.
 */
export function PlanPreview() {
  const model = useVenue((s) => s.model);
  const units = useVenue((s) => s.units);
  const insets = useVenue((s) => s.insets);
  const drawing = useVenue((s) => s.engineDrawing);
  const [size, setSize] = useState({ w: innerWidth, h: innerHeight });
  const plan = useMemo(() => (model ? buildPlanDrawing(model) : null), [model]);

  useEffect(() => {
    const onResize = () => setSize({ w: innerWidth, h: innerHeight });
    addEventListener('resize', onResize);
    return () => removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    if (plan) requestAnimationFrame(() => venue().mark('plan'));
  }, [plan]);

  if (!plan || drawing) return null;
  const m = planMapping(fitPlan(plan.extent, size.w, size.h, insets), size.w, size.h);
  return (
    <div className="overlay preview" aria-hidden="true">
      <svg>
        <g className="plan filled" transform={`matrix(${m.s} 0 0 ${-m.s} ${m.ox} ${m.oy})`} dangerouslySetInnerHTML={{ __html: plan.svg }} />
      </svg>
      {plan.labels.map((l, i) => (
        <div
          key={i}
          className={l.kind === 'dim' ? 'measure dim' : 'measure dim note'}
          style={{
            transform: `translate3d(${Math.round(m.ox + l.at[0] * m.s + (l.nudge?.[0] ?? 0))}px, ${Math.round(m.oy - l.at[1] * m.s + (l.nudge?.[1] ?? 0))}px, 0) translate(-50%, -50%)`,
          }}
        >
          {l.text ?? formatLength(l.metres ?? 0, units)}
        </div>
      ))}
    </div>
  );
}
